import React, { useState } from 'react';
import { BellRing, BellOff } from 'lucide-react';
import { toast } from 'sonner';

const MODES = [['jobs', 'Job mail'], ['all', 'All mail'], ['off', 'Off']];

/** Desktop alert preference for new mail (stored locally per PC — that's where the pop shows). */
export const MailAlertsToggle = ({ compact = false }) => {
  const [mode, setMode] = useState(localStorage.getItem('mail_alerts') || 'jobs');
  const [perm, setPerm] = useState(typeof Notification !== 'undefined' ? Notification.permission : 'unsupported');

  const pick = async (m) => {
    setMode(m); localStorage.setItem('mail_alerts', m);
    if (m !== 'off' && perm === 'default') {
      const p = await Notification.requestPermission();
      setPerm(p);
      if (p === 'granted') new Notification('365Ops alerts on', { body: m === 'jobs' ? 'You’ll get a pop when mail with a WO or quote number lands.' : 'You’ll get a pop for every new email.' });
      else toast.info('Browser pop-ups are blocked — you’ll still get the in-app toast.');
    }
  };

  return (
    <div className={`inline-flex items-center gap-1 ${compact ? '' : 'rounded-xl border border-slate-200 bg-white/80 px-2 py-1'}`} data-testid="mail-alerts-toggle" title="Desktop alerts for new mail on this PC">
      {mode === 'off' ? <BellOff className="w-3.5 h-3.5 text-slate-400" /> : <BellRing className="w-3.5 h-3.5 text-sky-600" />}
      {MODES.map(([m, label]) => (
        <button key={m} onClick={() => pick(m)} data-testid={`mail-alerts-${m}`}
          className={`text-[11px] px-2 py-0.5 rounded-lg font-semibold transition-colors ${mode === m ? 'bg-sky-600 text-white' : 'text-slate-600 hover:bg-slate-100'}`}>{label}</button>
      ))}
      {perm === 'denied' && mode !== 'off' && <span className="text-[10px] text-amber-700 ml-1">pop-ups blocked in browser</span>}
    </div>
  );
};
